module.exports = "/ui/main/images/boxnow.png?0e2901919a49d98540af276d2c732cf3";